import { RentalCalculation } from "../lib/models/rental/rental-calculation.model";
import { FixAndFlipCalculation } from "../lib/models/short-term/short-term-calculation.model";
import { isInternalUser } from "../lib/UserPermissions";
import useGetUserRole from "./useGetUserRole";
import useQuote from "./useQuote";

export default function useGetFormTabs() {
  const role = useGetUserRole();
  const quote = useQuote();

  const { hasCalculationErrors, quoteCalculation, isNewQuote } = quote.state;

  const calculationExists = quoteCalculation !== null;

  quoteCalculation as RentalCalculation | FixAndFlipCalculation;

  if (isInternalUser(role) && !quoteCalculation?.isRestrictedZip) {
    return getTabs(
      hasCalculationErrors ?? false,
      calculationExists,
      isNewQuote
    );
  }

  return getTabsWithoutOverrides(calculationExists);
}

const getTabsWithoutOverrides = (calculationExists?: boolean) => {
  if (calculationExists) {
    return ["Details", "Calculation"];
  }
  return ["Details"];
};

const getTabs = (
  hasCalculationErrors: boolean,
  calculationExists: boolean,
  isNewQuote: boolean
) => {
  if (!hasCalculationErrors && !isNewQuote) {
    return ["Details", "Calculation", "Exceptions", "Discussion"];
  } else if (calculationExists && !isNewQuote) {
    return ["Details", "Calculation", "Exceptions"];
  } else if (calculationExists) {
    return ["Details", "Calculation"];
  }

  return ["Details"];
};
